// Общие опции KaTeX / rehype-katex для учебных поверхностей.
//
// `strict: 'warn'` по умолчанию логирует каждый unknownSymbol в console —
// при стриме tutor-ответа это легко даёт 1000+ одинаковых warn.
// Типографские тире чиним в `normalizeMathDelimiters`; здесь глушим
// оставшиеся unknownSymbol, остальное оставляем warn.

import type { KatexOptions } from "katex";

export const KATEX_OPTIONS: KatexOptions = {
	throwOnError: false,
	strict: (errorCode) => (errorCode === "unknownSymbol" ? "ignore" : "warn"),
};
